import React from "react";
import OurProcess from "../About/OurProcess";
import HowItWorks from "../Home/HowItWork";
import StatsSection from "../Home/StatsSection";
import WhyChooseUs from "../Home/WhyChooseUs";
import FAQSection from "../Home/FAQSection";
import CTASection from "../Home/CTABanner";
import PricingHero from "./PricingHero";
import PricingSection from "./PricingSection";
import SpecialtyPricingSection from "./SpecialtyPricingSection";
import SEO from "../../components/Common/SEO";

const Pricing = () => {
  return (
    <>
      <SEO page="pricing" />
      <PricingHero />
      <PricingSection />
      <SpecialtyPricingSection />
      <OurProcess />
      <HowItWorks />
      <StatsSection />
      <WhyChooseUs />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default Pricing;
